import { render, staticRenderFns } from "./ITRQSummary.vue?vue&type=template&id=04ac7c4e&scoped=true&"
import script from "./ITRQSummary.vue?vue&type=script&lang=ts&"
export * from "./ITRQSummary.vue?vue&type=script&lang=ts&"
import style0 from "./ITRQSummary.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ITRQSummary.vue?vue&type=style&index=1&id=04ac7c4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ac7c4e",
  null
  
)

export default component.exports